import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/styles';
import IconMessage from 'components/Shared/IconMessage';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import React from 'react';

const EmptyList = ({ classes, message }: any) => (
  <Paper className={classes.emptyMetrics} elevation={0}>
    <Box alignContent='center' flexGrow={1}>
      <IconMessage icon={() => <ErrorIcon width={50} height={50} />} message={message} />
    </Box>
  </Paper>
);

export default withStyles({
  emptyMetrics: {
    width: '100%',
  }
})(EmptyList);